// @ts-strict-ignore
import { CmsApiAnchorBlockData } from 'modules/cms/api/types/CmsApiAnchor';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAnchorBlock } from './CmsAnchorBlock';

export const CmsAnchorBlockMapping: CmsBlockMapping<CmsApiAnchorBlockData> = {
  invariant: [
    {
      prop: 'anchor',
      msg: 'Anchor required for anchor',
    },
  ],
  width: CmsBlockWidth.GRID,
  Component: CmsAnchorBlock,
  AmpComponent: null,
};
